import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }                          from '../shared/shared.module';
import { TransactionCenterBookingsModule }       from './bookings/transaction-center.bookings.module';
import { TransactionCenterComponent }            from './transaction-center.component';
import { TransactionCenterInspectionsModule }    from './inspections/transaction-center.inspections.module';
import { TransactionCenterJobsModule }           from './jobs/transaction-center.jobs.module';
import { TransactionCenterOrdersModule }         from './orders/transaction-center.orders.module';
import { TransactionCenterService }              from './transaction-center.service';
import { TransactionCenterStates }               from './transaction-center.states';
import { TransactionCenterVendorInvoicesModule } from './vendor-invoices/transaction-center.vendor-invoices.module';

@NgModule({
  declarations: [
    TransactionCenterComponent
  ],
  entryComponents: [
    TransactionCenterComponent
  ],
  imports: [
    SharedModule,
    TransactionCenterBookingsModule,
    TransactionCenterInspectionsModule,
    TransactionCenterJobsModule,
    TransactionCenterOrdersModule,
    TransactionCenterVendorInvoicesModule,

    UIRouterUpgradeModule.forChild({ states: TransactionCenterStates })
  ],
  providers: [
    TransactionCenterService
  ]
})
export class TransactionCenterModule {}
